import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment as config } from '../../../../environments/environment';
import { merge } from 'ramda/es';
import * as languageList from 'language-list';
import { tap, filter } from 'rxjs/operators';
import { app_themes } from '../../../theme/themes.const';
import { ThemeService } from '../../../theme/theme.service';
import * as store from 'store';
import { ThemeDirective } from '../../../theme/theme.directive';
import { eva_constants } from '../../../eva_constants';
import { SessionsService } from '../../sessions/sessions.service';
import { FormBuilder, Validators } from '@angular/forms';
import { IChannel } from '../../../models/channel';
import { CustomizationService } from '../../customization/customization.service';
import { AuthService } from '../../auth/auth.service';
import { ITag } from '../../../models/tag';
import { reduce, has } from 'ramda';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { ICategory } from '../../../models/category';

@Component({
  templateUrl: './configure.component.html',
  styleUrls: ['./configure.component.scss', '../../../../assets/styles/imports/_ngxchips.scss']
})
export class ConfigureChannelComponent implements OnInit {
  public channel: IChannel;
  public channelForm: any;
  public theme: String = eva_constants.EVA_THEME;
  public displayNameTag: ITag;
  public categoryIdsToRemove = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private sessionsService: SessionsService,
    private customizationService: CustomizationService,
    private themeService: ThemeService,
    private fb: FormBuilder
  ) {
    this.channelForm = this.fb.group({
      name: ['', [Validators.required, Validators.maxLength(50)]],
      categories: Array<ICategory>()
    });
  }

  ngOnDestroy() {}

  ngOnInit() {
    this.loadCategories();
    if (this.route && this.route.data) {
      this.route.data.subscribe(data => {
        this.bindTheme(data);
        this.bindChannelUrl();
      });
    }

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        tap(() => {
          if (!this.route.snapshot.firstChild) return;
          const { data } = this.route.snapshot.firstChild;
          this.bindTheme(data);
          this.bindChannelUrl();
        })
      )
      .subscribe(null);

    this.customizationService.getAccountTag(eva_constants.ACCOUNT_DISPLAYNAME_TAG).subscribe(x => {
      if (x && x.value) {
        this.channel = merge(this.channel, { name: x.value });
        this.displayNameTag = x;
      }
    });
  }

  loadCategories() {
    this.sessionsService.getAllCategories().subscribe(categories => {
      this.channelForm.patchValue({
        categories: categories.map(c => ({ value: c.id, display: c.name, pristine: true }))
      });
    });
    this.categoryIdsToRemove = [];
  }

  bindTheme(data) {
    if (!data) return;
    if (!data.theme) data.theme = store.get(ThemeDirective.THEME);

    let newTheme: any;
    if (data.theme) {
      const appTheme = app_themes[data.theme];
      if (appTheme) {
        this.theme = data.theme;
        newTheme = data.theme;
      }
    }
    if (newTheme) this.themeService.setActiveTheme(newTheme);
  }

  bindChannelUrl() {
    const user = JSON.parse(AuthService.retrieve(AuthService.USER_KEY) || '{}');
    if (user && user.name) {
      const isMyLiveTV = this.theme && this.theme === eva_constants.MYLIVETV_THEME;
      const shortBaseUrl = isMyLiveTV
        ? this.sessionsService.fixLinkForMyLiveTV(config.livee.short)
        : config.livee.short;
      this.channel = merge(this.channel, { url: `${shortBaseUrl}event/${user.name}` });
    }
  }
  doEdit() {
    this.channelForm.patchValue({ name: this.channelForm.value.name.trim() });
    const tag = merge(this.displayNameTag, { value: this.channelForm.value.name, type: 'text' });
    if (!tag.name) tag.name = eva_constants.ACCOUNT_DISPLAYNAME_TAG;
    if (!tag.description) tag.description = eva_constants.ACCOUNT_DISPLAYNAME_TAG;
    const lang = 'french'; //store.get(config.translations.key);
    const updateTag$ = this.customizationService.updateAccountTag(tag, lang);

    const value = this.channelForm.controls['categories'].value;
    const addOrUpdateCategory$ = reduce(
      (acc, c: any) => {
        if (!has('pristine')(c)) {
          return [...acc, this.sessionsService.addCategory(c.display)];
        }
        if (has('pristine')(c) && c.pristine === false) {
          return [...acc, this.sessionsService.updateCategory({ id: c.value, name: c.display })];
        }
        return acc;
      },
      [],
      value
    );
    const removeCategory$ = this.categoryIdsToRemove.map(id =>
      this.sessionsService.deleteCategory(id)
    );

    forkJoin([updateTag$, ...addOrUpdateCategory$, ...removeCategory$]).subscribe(
      () => {
        toastr.success(this.translateService.instant('action.success'));
        this.loadCategories();
        this.channelForm.pristine = true;
      },
      () => {
        toastr.error(this.translateService.instant('action.failed'));
      }
    );
  }

  onCopySuccess() {
    toastr.success(this.translateService.instant('channel.copied_success'));
  }

  onRemoveCategory($event) {
    if (has('pristine')($event)) {
      this.categoryIdsToRemove.push($event.value);
    }
  }

  onCategoryTagEdited($event) {
    const ctl = this.channelForm.controls['categories'];
    if (has('pristine')(ctl.value[$event.index])) {
      ctl.value[$event.index].pristine = false;
    }
    this.channelForm.pristine = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/channel/configure/configure.component.ts